import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const ManagerIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 21.4664L8.449 12.9782C8.33689 12.6899 8.05931 12.5 7.75 12.5H5.75C4.23122 12.5 3 13.7312 3 15.25V22.25C3 22.6642 3.33579 23 3.75 23H19.75C20.1642 23 20.5 22.6642 20.5 22.25V15.25C20.5 13.7312 19.2688 12.5 17.75 12.5H15.75C15.4407 12.5 15.1631 12.6899 15.051 12.9782L11.75 21.4664Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.112 12.8555C10.2487 12.6343 10.4901 12.4998 10.75 12.4998H12.75C13.0099 12.4998 13.2513 12.6343 13.388 12.8555C13.5246 13.0766 13.5371 13.3527 13.4208 13.5852L12.5224 15.3821L12.9942 19.1567C13.0081 19.2679 12.9969 19.3807 12.9615 19.4869L12.4615 20.9869C12.3594 21.2932 12.0728 21.4998 11.75 21.4998C11.4272 21.4998 11.1406 21.2932 11.0385 20.9869L10.5385 19.4869C10.5031 19.3807 10.4919 19.2679 10.5058 19.1567L10.9776 15.3821L10.0792 13.5852C9.96293 13.3527 9.97536 13.0766 10.112 12.8555Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 5.74976C7.5 3.40255 9.40279 1.49976 11.75 1.49976C14.0972 1.49976 16 3.40255 16 5.74976V6.74976C16 9.09697 14.0972 10.9998 11.75 10.9998C9.40279 10.9998 7.5 9.09697 7.5 6.74976V5.74976Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
